module.exports = __webpack_public_path__ + "static/media/Ecommerce-development.87e9da60.png";